import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Services from "../pages/services/page";
import Expertise from "../pages/expertise/page";
import About from "../pages/about/page";
import Testimonials from "../pages/testimonials/page";
import Booking from "../pages/booking/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/services",
    element: <Services />,
  },
  {
    path: "/expertise",
    element: <Expertise />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/testimonials",
    element: <Testimonials />,
  },
  {
    path: "/booking",
    element: <Booking />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;